module.exports = __webpack_public_path__ + "static/media/membrete.fd3ac5f4.jpeg";